import { useAuthUser } from '@react-query-firebase/auth';
import { useEffect } from 'react';
import { firebaseAuth } from '@rabbit/firebase/react';
import { getOrCreateIdentity } from '../identity';

export function PortalServices() {
  const user = useAuthUser(['user'], firebaseAuth);

  // console.log('PORTAL SERVICE');

  useEffect(() => {
    if (user.data) {
      console.log('User has signed in', user.data.uid);
      // Make sure their identity is up to date
      void getOrCreateIdentity(); // We don't need to await this
    } else {
      console.log('User has signed out');
    }
  }, [user.data?.uid]);

  return null;
}
